import { JSONLikeObject } from "@cede/types";

export const objectToMap = (obj: { [key: string]: JSONLikeObject }) => {
  const map = new Map();
  for (const key in obj) {
    map.set(key, obj[key]);
  }
  return map;
};
